<template>
	<div class="content-wrapper">
		<div class="sf-col-20" style="display: flex; justify-content: space-evenly">
			<!-- 그래프 부분 시작 -->
			<div class="sf-col">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-pcm-regn-tap-1-graph ref="graph" :scrId="scrId"></pc-pcm-regn-tap-1-graph>
				</sf-card>
				<sf-card class="p-0 border-0 bg-transparent" height="320px">
					<pc-pcm-regn-tap-1-table ref="table" :scrId="scrId"></pc-pcm-regn-tap-1-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcPcmRegnTap1Graph from './PcPcmRegnTap1Graph.vue';
import PcPcmRegnTap1Table from './PcPcmRegnTap1Table.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: { PcPcmRegnTap1Graph, PcPcmRegnTap1Table },
	methods: {}
};
</script>

<style></style>
